import { useLazyQuery } from "@apollo/client/react";import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { generateColumnsDefaultConfiguration } from '../../../../components/dataGrid/columnHelpers';
import DataGridGenerico from '../../../../components/dataGrid/DataGridGenerico';
import { GET_DOCUMENTOS_RI } from '../../../../data/graphQL/queries/MisTareas/getDocumentosRI';

import fileDownload from 'js-file-download';
import VisibilityIcon from '@mui/icons-material/Visibility';

import './mobileMisTareasDocuments.scss';

export const MobileMisTareasDocuments = ({ setChildrenAction, setHeaderContent, setFooterContent }) => {
  const location = useLocation();
  const stateData = location.state.data;

  const [rows, setRows] = useState([]);

  const initialColumns = [
  {
    field: 'tipoDocumento',
    flex: 4,
    headerAlign: 'left',
    headerName: 'Tipo'
  },
  {
    field: 'titulo',
    headerAlign: 'left',
    align: 'left',
    flex: 5,
    headerName: 'Documento'
  },
  {
    flex: 2,
    align: 'right',
    renderCell: (cellProps) => {
      const { row } = cellProps;
      return (
        <VisibilityIcon onClick={() => handleDownload(row)} className='edit-icon' sx={{ padding: 0, margin: 0 }} />);

    }
  }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns, true), null);

  const [getDocumentosRI, { data: documentosData, loading: documentosLoading }] = useLazyQuery(GET_DOCUMENTOS_RI, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!documentosData) return;
    setRows(documentosData.documentosRI.valorEsperado);
  }, [documentosData]);  

  useEffect(() => {
    if (!documentosLoading) {
      getDocumentosRI({ variables: { idDatosGeneralesRI: parseInt(stateData?.idDatosGeneralesRI, 10) } });
    }
  }, []);

  const handleDownload = (row) => {
    const arr = new Uint8Array(row.archivo);
    const documento = new Blob([arr], { type: row.contentType });
    const fileName = row.titulo + row.extension;

    fileDownload(documento, fileName);
  };

  const handleRowClick = (params) => {
    handleDownload(params.row);
  };

  return (
    <>
            <div className='general'>            
                <h3>Paciente / {stateData?.paciente}</h3>
                <DataGridGenerico
          columns={columns}
          rows={rows}
          toolbar={false}
          loading={documentosLoading}
          onRowClick={handleRowClick} />
        
            </div>
        </>);


};